
















//Component
import Popover, { PopoverProps } from "./Popover.vue";
import { defineComponent, ref, computed, watch } from "@vue/composition-api";
import useCancelButton from "@/composables/buttons/useCancelButton";
import useSaveButton from "@/composables/buttons/useSaveButton";
import { DateTime } from "luxon";
import DatePicker from "./DatePicker.vue";

export default defineComponent({
  components: { Popover, DatePicker },
  props: {
    ...PopoverProps,
    expirationDate: {
      type: String,
      required: false,
    },
    elementId: {
      type: String,
      required: true,
    },
  },
  emits: ["updateExpirationDate"],
  setup(props, { emit }) {
    const show = ref(false);
    const expiration = ref<DateTime | undefined>(undefined);
    const onOpen = () => {
      show.value = true;
    };

    const onClose = () => {
      show.value = false;
    };

    const expirationTime = computed<DateTime | undefined>({
      get() {
        return expiration.value;
      },
      set(newValue: DateTime | undefined) {
        expiration.value = newValue;
      },
    });

    watch(
      () => props.expirationDate,
      (newValue) => {
        if (newValue) {
          expiration.value = DateTime.fromISO(newValue, { zone: "utc" });
        } else {
          expiration.value = undefined;
        }
      }
    );

    return {
      show,
      onOpen,
      onClose,
      expirationTime,
      primaryButton: useSaveButton(() => {
        const isoString = expiration.value
          ?.startOf("day")
          .setZone("utc", { keepLocalTime: true })
          .toISO();

        emit("updateExpirationDate", {
          elementId: props.elementId,
          expirationDate: isoString,
        });
        expiration.value = undefined;
        onClose();
      }),
      secondaryButton: useCancelButton(() => {
        if (!props.expirationDate) {
          expiration.value = undefined;
        }
        onClose();
      }),
    };
  },
});
